window.radio_button_background_color_change_operation = function(input_field_name) {
	get_radio_button_wrapper_identifier_by_field_name(input_field_name)
		.removeClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME + " " + UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
	radio_button_add_choosen_background_color_operation(input_field_name);
}

window.radio_button_add_choosen_background_color_operation = function(input_field_name) {
	get_radio_button_wrapper_identifier_by_field_name(input_field_name, true)
		.addClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
}

window.radio_button_background_color_reset_operation = function(input_field_name) {
	get_radio_button_wrapper_identifier_by_field_name(input_field_name)
		.removeClass(SELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME)
		.addClass(UNSELECTED_OPTION_BACKGROUND_COLOR_CLASS_NAME);
}

function get_radio_indentifier_by_field_name(input_field_name, checked = false) {
	let radio_option_idenfifier_name = "input[name='" + input_field_name + "'][type='radio']";
	if(checked) radio_option_idenfifier_name += ":checked";
	return radio_option_idenfifier_name;
}

function get_radio_button_wrapper_identifier_by_field_name(input_field_name, checked = false) {
	let radio_option_indentifier = get_radio_indentifier_by_field_name(input_field_name, checked);
	return $(radio_option_indentifier).closest("." + CHECKBOX_AND_RADIO_OPTIONS_PARENT_WRAPPER_CLASSNAME);
}

$(function() {

	$("input[type='radio']").on("click", function() {
		radio_button_background_color_change_operation(this.name);
	});

});